import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap4-modal';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import 'assets/scss/upgradeModal.css';
import growthIcon from 'assets/img/growth_icon.svg';
import { withRouter } from 'react-router';

const UpgradeModal = ({
  isVisible,
  toggleModal,
  history,
  headText,
  subHeadText,
}) => {
  const handleUpgrade = () => {
    history.push('/renew/select-plan');
  };

  return (
    <Modal
      className="upgrade-modal"
      visible={isVisible}
      onClickBackdrop={toggleModal}
    >
      <div className="modal-body text-center">
        <div className="row">
          <div className="col-md-5 left-side-info">
            <h2 className="mb-3">Ready to Upgrade?</h2>
            <p className="mb-4">
              Upgrade to a premium plan and watch your business grow.
            </p>
            <button
              type="button"
              className="btn btn-warning text-white pl-5 pr-5 p-2 text-bold"
              onClick={handleUpgrade}
            >
              UPGRADE PLAN <FontAwesomeIcon icon="arrow-up" className="ml-2" />
            </button>
          </div>
          <div className="col-md-7 right-side-info">
            <span
              onClick={e => {
                e.preventDefault();
                toggleModal();
              }}
              className="close-modal cursor-pointer"
            >
              <FontAwesomeIcon icon="times-circle" />
            </span>
            <img src={growthIcon} className="mb-5" />
            <h2 className="mb-3">{headText}</h2>
            <p>{subHeadText}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

UpgradeModal.defaultProps = {
  isVisible: false,
  toggleModal: () => {},
};

UpgradeModal.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  headText: PropTypes.string.isRequired,
  subHeadText: PropTypes.string.isRequired,
};

export default withRouter(UpgradeModal);



// WEBPACK FOOTER //
// ./src/components/Modal/UpgradeModal/UpgradeModal.js